import React from 'react';
import {Link} from 'react-router';

class Package extends React.Component {
    render() {
        const {completedMeditationsCount, meditationsCount, title, description, id, hideDescription} = this.props;
        let className = this.props.className || "";
        let progress = null;

        if (meditationsCount) {
            if (completedMeditationsCount) {
                progress = <div className="progress"><span>{completedMeditationsCount}</span> от <span>{meditationsCount}</span></div>
                if (completedMeditationsCount === meditationsCount) {
                    className += " done";
                }
            }
            else {
                progress = <div className="progress"><span>{meditationsCount}</span> {meditationsCount === 1 ? "сесия" : "сесии"}</div>
            }
        }
        className += " package";
        return <Link to={`/meditate/${id}`} className={className}>
            <h4>{title}</h4>
            {!hideDescription ? <p>{description}</p> : null}
            {progress}
        </Link>
    }
}

export default Package;


// WEBPACK FOOTER //
// ./src/components/Presentation/Package.js